import React, { FC, RefObject, useContext } from "react";
import { observer } from 'mobx-react-lite';
import { LeftPaneContext } from '../LeftPaneContext';
import { LeftPaneSelectedSection } from '../../../../constants';
import { SequenceNode } from './SequenceNode';

// for now there is only one "initialSequence" but one day there will be multiple "initialSequences"
// so for now and only now, we will assume a sequence is a child sequence if it does not have the same uuid as the "initialSequence"
// we will likely have to revisit this logic when we have multiple initial sequences

interface  ChildSequencesProps {
  treeViewRef: RefObject<HTMLDivElement>;
}

export const ChildSequences: FC<ChildSequencesProps> = observer(({ treeViewRef }) => {

  const { library, selectedSection } = useContext(LeftPaneContext);

  const currentApplication = library.currentApplication;
  if(!currentApplication) { return null; }

  const initialSequence = currentApplication.initialSequence;
  const childSequences = currentApplication.sequences.filter((sequence) => sequence.uuid !== initialSequence.uuid);
  const selectedSequence = currentApplication.currentSequence;

  return (
    <div className='sequence-container'>
      {childSequences.length === 0 && <span className='no-sequence' ><i>Click "+" to add a new child sequence</i></span> }
      {childSequences.map((sequence, index) => {
        const isSequenceSelected = selectedSequence?.uuid === sequence.uuid && selectedSection === LeftPaneSelectedSection.SEQUENCES;
        return (
          <SequenceNode
            key={ index }
            sequence={ sequence }
            isSelected={ isSequenceSelected }
            isInitialSequence={ false }
            parentRef={ treeViewRef }
          />
        );
      })}
    </div>
  );
});